export const DEFAULT_CATEGORY_VALIDATION = {
  isValid: true,
  errorByAttribute: {
    searchUrl: '',
    slug: '',
    title: ''
  }
};
